module.exports = __webpack_public_path__ + "static/media/fly-rod-before.17381c2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/digitalNomad/photo-editing/fly-rod-before.jpg
// module id = 376
// module chunks = 0